import { TaggedError } from "../tagged-error.js";
export class EmailAlreadyValidatedError extends TaggedError {
    constructor() {
        super("EmailAlreadyValidatedError");
    }
}
